import { CampaignsBase } from './CampaignsBase';
import { Helper } from '../../../common/helpers/Helper';

export class Ooh extends CampaignsBase {
  constructor(props, options) {
    super(props, {
      ...options,
      pageTitle: Helper.getString('ooh'),
      campaignType: 'AD',
      assetPicker: true,
    });
  }
}
